<nz-form-item [formGroup]="formConfig.parentForm">
	<nz-form-label [nzSpan]="6">{{ schema?.title || schemaKey | translate }}</nz-form-label>
	<nz-form-control [nzSpan]="18" [nzErrorTip]="errorTemplate">
		<input *ngIf="formConfig.viewOnly"
				nzBorderless nz-input [formControlName]="key"
				class="ft-view" [type]="format"
		/>
		<vaadin-date-picker *ngIf="!formConfig.viewOnly"
				[formControlName]="key"
				class="ft-edit datepicker"
				[required]="required"
				[initialPosition]="initialDate"
				(ngModelChange)="setValid($event)"
		></vaadin-date-picker>
		<ng-template #errorTemplate let-control>
			<ng-container *ngIf="control.hasError('validation')">{{control.errors.validation}}</ng-container>
			<ng-container *ngIf="control.hasError('required')">{{ 'form.input.required' | translate:{itemName : schema?.title || schemaKey | translate } }}</ng-container>
		</ng-template>
	</nz-form-control>
</nz-form-item>
